module.exports = __webpack_public_path__ + "static/media/from-device.c86f81ff.svg";